export const linkResolver = doc => {
  if (doc.type === 'application') return `/applications/${doc.uid}`;
  if (doc.type === 'product') return `/${doc.categoryUid}/${doc.uid}`;
  return '/';
};
